// extracted by mini-css-extract-plugin
module.exports = {"stat":"style-module__stat___klo1y","statValue":"style-module__statValue___RK_UV"};